import { IProductsData, IProductsAction } from 'models/product/products';
import { IPage } from 'models/common';
import { IProductListItemCard } from 'models/product/productlistitem';
import { IStore } from 'redux/IStore';
import * as c from 'models/constants';
import * as i18n from 'i18next';
import { actions as notifActions } from 'redux-notifications';
const { notifSend } = notifActions;
import { IUserPreferences } from 'models/user/userpreferences';
import { Wishlists } from 'redux/modules/user/wishlists';
import { WishlistNodeType } from 'models/enums/nodetype/wishlistnodetype';
import { LikeNodeType } from 'models/enums/nodetype/likenodetype';
import { Likes } from 'redux/modules/user/likes';
import { IProductsRequest } from 'models/product/search/productsRequest';
import { IProductSearchResultsData } from 'models/search/productbasesearchresults';
import { ProductsSort } from 'models';

/** Action Types */
export const REQUEST_START: string = 'products/REQUEST_START';
export const REQUEST_FAILURE: string = 'products/REQUEST_FAILURE';
export const SET_ITEMS_PAGE: string = 'products/SET_ITEMS_PAGE';
export const RESET_DATA: string = 'products/RESET_DATA';
export const GET_PRODUCTS_SUCCESS: string = 'products/GET_PRODUCTS_SUCCESS';
export const CHANGE_SELECTED_TAB: string = 'products/CHANGE_SELECTED_TAB';
export const SET_SORT_ORDER: string = 'products/SET_SORT_ORDER';
export const SET_SEARCH_FILTER: string = 'products/SET_SEARCH_FILTER';
export const SET_ISFIRSTLOAD: string = 'products/SET_ISFIRSTLOAD';
export const CLEAR_PRODUCTS_ERROR: string = 'products/CLEAR_PRODUCTS_ERROR';
export const SET_SELECTED_PRODUCTS: string = 'products/SET_SELECTED_PRODUCTS';
export const LIKE_ITEM_SUCCESS: string = 'products/LIKE_ITEM_SUCCESS';
export const LIKE_REQUEST_START: string = 'products/LIKE_REQUEST_START';
export const LIKE_REQUEST_FAILURE: string = 'products/LIKE_REQUEST_FAILURE';
export const WISHLIST_ITEM_SUCCESS: string = 'products/WISHLIST_ITEM_SUCCESS';

/** Initial State */
const initialState: IProductsData = {
	items: [],
	isFetching: false,
	isFetchingLikes: false,
	itemsPage: {
		currentPage: 0,
		totalPages: 0,
		totalItems: 0,
		itemsPerPage: 10,
		items: [],
	},
	selectedTab: c.PRODUCTS_TAB_PRODUCTS,
	keywordFilter: '',
	sortOrder: null,
	isFirstLoad: true,
	selectedProducts: [],
};

/** Reducer */
export function productsReducer(state = initialState, action: IProductsAction) {
	switch (action.type) {
		case REQUEST_START:
			return Object.assign({}, state, {
				isFetching: true,
				error: false,
			});

		case REQUEST_FAILURE:
			return Object.assign({}, state, {
				isFetching: false,
				message: action.payload.message,
				error: true,
			});

		case SET_ITEMS_PAGE:
			return Object.assign({}, state, {
				itemsPage: action.payload.itemsPage,
			});

		case RESET_DATA:
			return Object.assign({}, state, {
				items: [],
				itemsPage: {
					currentPage: 0,
					totalPages: 0,
					totalItems: 0,
					itemsPerPage: 10,
					items: [],
				},
				selectedProducts: [],
			});

		case GET_PRODUCTS_SUCCESS:
			return Object.assign({}, state, {
				items: action.payload.items,
				isFetching: false,
			});

		case WISHLIST_ITEM_SUCCESS:
			return Object.assign({}, state, {
				isFetching: false,
			});

		case LIKE_REQUEST_START:
			return Object.assign({}, state, {
				isFetchingLikes: true,
			});

		case LIKE_ITEM_SUCCESS:
			return Object.assign({}, state, {
				isFetchingLikes: false,
			});

		case LIKE_REQUEST_FAILURE:
			return Object.assign({}, state, {
				isFetchingLikes: false,
				message: action.payload.message,
				error: true,
			});

		case CHANGE_SELECTED_TAB:
			return Object.assign({}, state, {
				selectedTab: action.payload.selectedTab,
				tabNamespace: action.payload.tabNamespace,
			});

		case SET_SEARCH_FILTER:
			return Object.assign({}, state, {
				keywordFilter: action.payload.keywordFilter,
				isFirstLoad: true,
			});

		case SET_SORT_ORDER:
			return Object.assign({}, state, {
				sortOrder: action.payload.sortOrder,
				isFirstLoad: true,
			});

		case SET_ISFIRSTLOAD:
			return Object.assign({}, state, {
				isFirstLoad: action.payload.isFirstLoad,
			});

		case CLEAR_PRODUCTS_ERROR:
			return Object.assign({}, state, {
				isFetching: false,
				message: null,
				error: false,
			});

		case SET_SELECTED_PRODUCTS:
			return Object.assign({}, state, {
				selectedProducts: action.payload.selectedProducts,
			});

		default:
			return state;
	}
}

/** Action Creator */
export function getProductsByShop(id: string, publishedOnly = true, groupVariants = true) {
	return (dispatch, getState: () => IStore) => {
		if (getState().products.isFirstLoad) {
			dispatch(resetData());
			dispatch(setIsFirstLoad(false));
		}

		dispatch(requestStart());

		const currentPage: number = getState().products.itemsPage.currentPage;
		const newPage: number = currentPage + 1;
		const itemsPerPage: number = getState().products.itemsPage.itemsPerPage;
		const userPreferences: IUserPreferences = getState().userPreferences;

		const productsRequest: IProductsRequest = {
			currentPage: newPage,
			itemsPerPage,
			published: publishedOnly,
			groupVariants,
			orderBy: getState().products.sortOrder,
		};

		if (getState().products.keywordFilter && getState().products.keywordFilter !== '') {
			productsRequest.searchKeyword = getState().products.keywordFilter;
		}

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Product/GetByShop/' + id,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
				body: JSON.stringify(productsRequest),
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res) => {
						const productsData: IProductSearchResultsData = getState().products;
						const items: IProductListItemCard[] = productsData.items;
						const newItems: IProductListItemCard[] = res.products.items;
						Array.prototype.push.apply(items, newItems);
						dispatch(getProductsSuccess(items));
						dispatch(setItemsPage(res.products));
						const wishlists = new Wishlists(WishlistNodeType.Product);
						const likes = new Likes(LikeNodeType.Product);

						if (userPreferences && userPreferences.id) {
							dispatch(likes.getLikedItems());
							dispatch(wishlists.getWishlistedItems());
						} else {
							dispatch(likes.updateLikeItems(null));
							dispatch(wishlists.updateWishlistItems(null));
						}
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function changeTabAndGetRequiredData(selectedTab: string, tabNamespace: string, shopId: string) {
	return (dispatch) => {
		dispatch(changeSelectedTab(selectedTab, tabNamespace));

		switch (selectedTab) {
			case c.PRODUCTS_TAB_PRODUCTS:
				dispatch(getProductsByShop(shopId, false, false));
				break;

			case c.PRODUCTS_TAB_COLLECTIONS:
				break;

			default:
				break;
		}
	};
}

/** Action Creator */
export function selectProduct(id: string, select: boolean) {
	return (dispatch, getState: () => IStore) => {
		const selectedProducts: string[] = getState().products.selectedProducts;
		if (select) {
			if (selectedProducts.filter((x) => x === id).length === 0) {
				selectedProducts.push(id);
			}
		} else {
			if (selectedProducts.filter((x) => x === id).length > 0) {
				selectedProducts.splice(selectedProducts.indexOf(id), 1);
			}
		}

		dispatch(setSelectedProducts(selectedProducts));
	};
}

/** Action Creator */
export function selectAllProducts(select: boolean) {
	return (dispatch, getState: () => IStore) => {
		let selectedProducts: string[] = [];

		if (select) {
			selectedProducts = getState().products.items.map((product: IProductListItemCard) => {
				return product.id;
			});
		}

		dispatch(setSelectedProducts(selectedProducts));
	};
}

/** Async Action Creator */
export function deleteProducts(shopId: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());

		const selectedProducts: string[] = getState().products.selectedProducts;

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Product/DeleteProducts?shopId=' + shopId,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'DELETE',
				body: JSON.stringify(selectedProducts),
			}),
		)
			.then((res) => {
				if (res.ok) {
					dispatch(
						notifSend({
							message: i18n.t('Notification_Success_Products_Deleted'),
							kind: 'success',
							dismissAfter: 3000,
						}),
					);
					dispatch(setIsFirstLoad(true));
					dispatch(getProductsByShop(shopId, false, false));
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Async Action Creator */
export function deleteProduct(itemId: string, shopId: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());
		return fetch(
			getState().fetchDefault.baseAPI + 'api/Product/' + itemId,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'DELETE',
			}),
		)
			.then((res) => {
				if (res.ok) {
					dispatch(
						notifSend({ message: i18n.t('Notification_Success_Product_Deleted'), kind: 'success', dismissAfter: 3000 }),
					);
					dispatch(setIsFirstLoad(true));
					dispatch(getProductsByShop(shopId, false, false));
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Async Action Creator */
export function exportProducts(shopId: string, filename: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Product/Export?shopId=' + shopId,
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					return res.blob().then((blob) => {
						// 2. Create blob link to download
						const url = window.URL.createObjectURL(new Blob([blob]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', filename);
						// 3. Append to html page
						document.body.appendChild(link);
						// 4. Force download
						link.click();
						// 5. Clean up and remove the link
						link.parentNode.removeChild(link);
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function requestStart(): IProductsAction {
	return {
		type: REQUEST_START,
	};
}

/** Action Creator */
export function requestFailure(message: any): IProductsAction {
	return {
		type: REQUEST_FAILURE,
		payload: {
			message,
		},
	};
}

/** Action Creator */
export function setItemsPage(itemsPage: IPage): IProductsAction {
	return {
		type: SET_ITEMS_PAGE,
		payload: {
			itemsPage,
		},
	};
}

/** Action Creator */
export function resetData(): IProductsAction {
	return {
		type: RESET_DATA,
	};
}

/** Action Creator */
export function setSortOrder(sortOrder: ProductsSort): IProductsAction {
	return {
		type: SET_SORT_ORDER,
		payload: {
			sortOrder,
		},
	};
}

/** Action Creator */
export function getProductsSuccess(items: IProductListItemCard[]): IProductsAction {
	return {
		type: GET_PRODUCTS_SUCCESS,
		payload: {
			items,
		},
	};
}

/** Action Creator */
export function changeSelectedTab(selectedTab: string, tabNamespace: string): IProductsAction {
	return {
		type: CHANGE_SELECTED_TAB,
		payload: {
			selectedTab,
			tabNamespace,
		},
	};
}

export function setSearchFilter(keywordFilter: string): IProductsAction {
	return {
		type: SET_SEARCH_FILTER,
		payload: {
			keywordFilter,
		},
	};
}

export function setIsFirstLoad(isFirstLoad: boolean): IProductsAction {
	return {
		type: SET_ISFIRSTLOAD,
		payload: {
			isFirstLoad,
		},
	};
}

/** Action Creator */
export function clearProductsError(): IProductsAction {
	return {
		type: CLEAR_PRODUCTS_ERROR,
	};
}

export function setSelectedProducts(selectedProducts: string[]): IProductsAction {
	return {
		type: SET_SELECTED_PRODUCTS,
		payload: {
			selectedProducts,
		},
	};
}

/** Action Creator */
export function wishlistItemSuccess(): IProductsAction {
	return {
		type: WISHLIST_ITEM_SUCCESS,
	};
}

/** Action Creator */
export function likeItemSuccess(): IProductsAction {
	return {
		type: LIKE_ITEM_SUCCESS,
	};
}

/** Action Creator */
export function likeRequestStart(): IProductsAction {
	return {
		type: LIKE_REQUEST_START,
	};
}

/** Action Creator */
export function likeRequestFailure(message: any): IProductsAction {
	return {
		type: LIKE_REQUEST_FAILURE,
		payload: {
			message,
		},
	};
}
